import React from 'react';
import { Button, Container } from 'react-bootstrap';
import useModal from '../../hooks/useModal';
import { BankingAccountDetails } from './BankingAccountForm';
import BankingAccountFormModal from './BankingAccountFormModal';

const BankingAccountFormDemo = () => {
  const [showModal, handleShow, handleClose] = useModal();

  const [bankingAccountDetails] =
    React.useState<BankingAccountDetails>({
      accountNumber: '234234234',
      accountType: 'random',
      bank: 'DSK',
      accountName: 'My Saving Account',
    });

  const handleSubmit = () => {
    console.log('submit', bankingAccountDetails);
    handleClose();
  };

  return (
    <Container>
      <Container className="mt-10">
        <h4>Banking Account Form Modal</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center p-0">
          <Button variant="primary" onMouseDown={handleShow}>
            Add address
          </Button>
          <BankingAccountFormModal
            showModal={showModal}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
          />
        </Container>
      </Container>
    </Container>
  );
};

export default BankingAccountFormDemo;
